
import { Options, Vue } from 'vue-class-component'
import { defineAsyncComponent } from 'vue'

import Contacts from '@/components/Contacts.vue'
import AboutMe from '@/components/AboutMe.vue'
import Skills from '@/components/Skills.vue'

@Options({
  components: {
    AsyncPortfolio: defineAsyncComponent(() => import('@/components/Portfolio.vue')),
    AsyncDonate: defineAsyncComponent(() => import('@/components/Donate.vue' /* webpackChunkName: "donate" */)),
    Contacts,
    AboutMe,
    Skills,
  },
})
export default class Home extends Vue {
  // created() {}
}
